/**
 * cache help methods
 */
class Cache {
  constructor () {
    this.buffer = {
      nonMark: false, // 无痕浏览：用户数据不存本地，刷新即丢失
      zsData: {
        localData: {}, // 本地数据
        sessionData: {} // 动态数据
      }
    }

    this.keyMap = {
      'CACHE_STORE_ID': 'cache_store_id',
      'CACHE_STORE_STATUS': 'cache_store_status'
    }
    // 判断localStorage是否可用，不可用则设置为无痕模式
    if (!window.localStorage || !window.sessionStorage) {
      this.buffer.nonMark = true
    } else {
      try {
        window.localStorage.setItem('test', {})
        window.sessionStorage.setItem('test', {})
      } catch (e) {
        this.buffer.nonMark = true
      }
    }
  }
  /**
   * 设置会话数据，临时数据存储使用
   * @param key
   * @param val
   * @return {*}
   */
  setSessionData (key, val) {
    if (!this.buffer.nonMark && window.sessionStorage.setItem) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(val))
      } catch (e) {
        this.buffer.nonMark = true
        this.buffer.zsData.sessionData[key] = val
      }
    } else {
      this.buffer.zsData.sessionData[key] = val
    }
  }

  /**
   * 获取会话数据，临时数据存储使用
   * @param key
   * @return {*}
   */
  getSessionData (key) {
    if (!this.buffer.nonMark && window.sessionStorage.getItem) {
      var val = window.sessionStorage.getItem(key)
      return (val === null || val === '') ? val : JSON.parse(val)
    } else {
      return this.buffer.zsData.sessionData[key]
    }
  }

  setLocalStorageData (key, val) {
    if (!this.buffer.nonMark && window.localStorage.setItem) {
      try {
        window.localStorage.setItem(key, JSON.stringify(val))
      } catch (e) {
        this.buffer.nonMark = true
        this.buffer.zsData.localData[key] = val
      }
    } else {
      this.buffer.zsData.localData[key] = val
    }
  }

  getLocalStorageData (key) {
    if (!this.buffer.nonMark && window.localStorage.getItem) {
      var val = window.localStorage.getItem(key)
      return (val === null || val === '') ? val : JSON.parse(val)
    } else {
      return this.buffer.zsData.localData[key]
    }
  }

  clearSessionData (key) {
    if (window.sessionStorage.removeItem && !this.buffer.nonMark) {
      window.sessionStorage.removeItem(key)
    } else {
      this.buffer.zsData.sessionData[key] = []
    }
  }

  clearLocalStorageData (key) {
    if (window.localStorage.removeItem && !this.buffer.nonMark) {
      window.localStorage.removeItem(key)
    } else {
      this.buffer.zsData.localData[key] = []
    }
  }

  // 记录路由跳转前的 URL 页面信息
  // 服务于数据埋点，[进入页面来源] 关键字段
  setPrevActivePage(path) {
    this.setSessionData('PREV_ACTIVE_PAGE', path)
  }

  // 获取上次活动页面信息
  getPrevActivePage() {
    return this.getSessionData('PREV_ACTIVE_PAGE')
  }

  // 记录 wx agentConfig 是否执行失败
  setWechatAgentConfErr() {
    this.setSessionData('WECHAT_AGENT_CONF_ERR', 1)
  }

  getWechatAgentConfErr() {
    return this.getSessionData('WECHAT_AGENT_CONF_ERR')
  }
}
export default new Cache()

export const EXTERNAL_USERID_KEY = 'EXTERNAL_USERID_KEY'
